import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Box from "@material-ui/core/Box";
import { useSearchParams } from "react-router-dom";
import { useWorkOrdersContext } from "../context/workOrdersContext";
import { cmmsTheme } from "@setup/theme/cmms-theme";

type Props = {};

export const CraftsFilter = ({}: Props) => {
	const { state } = useWorkOrdersContext();
	const [searchParams, setSearchParams] = useSearchParams();

	const craft = searchParams.get("craft") ?? "";

	const handleFilter = (e: any) => {
		searchParams.set("craft", e.target.value);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<Box>
			<FormControl variant="outlined" margin="dense" fullWidth>
				<InputLabel id="crafts-select-label">Crafts</InputLabel>
				<Select
					labelId="crafts-select-label"
					id="crafts-select"
					value={craft}
					onChange={handleFilter}
					label="Crafts"
					style={cmmsTheme.styles.filterSelect}
				>
					{state.crafts.map((craft) => {
						return (
							<MenuItem key={`logId-${craft.id}`} value={craft.id}>
								<Grid container alignItems="center">
									<div
										style={{
											height: 20,
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											paddingLeft: 10,
										}}
									>
										<div
											style={{
												height: 24,
												width: 24,
												borderRadius: 4,
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												background:
													craft.color || cmmsTheme.colors.surfaceWhite,
											}}
										>
											<div
												style={{
													color: cmmsTheme.colors.surfaceWhite,
													fontWeight: 600,
													margin: "auto 0",
												}}
											>
												<div>{craft.description.charAt(0) || ""}</div>
											</div>
										</div>
									</div>
									<div style={{ marginLeft: 10 }}>{craft.description}</div>
								</Grid>
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</Box>
	);
};
